// The key figure card backgrounds that have no theme colour of their own. The contract dashboard's distribution chart
// uses them too, so its slices match the cards above it.
export const violetCardColor = "#D9BCFF";
export const pinkCardColor = "#F3BAED";
export const whiteCardShadow = "0px 3px 10px #E7E7E7";
